import { Stack, Button } from "@mui/material";
import styled from "@emotion/styled";
import { PRETTY_BLUE } from "../trips/form/BorderWithLabel";
export const offWhite = "#F9F9F9";
export const cardColor = "#EFEFEF";


export const StyledMultistartCard = styled( Stack, { shouldForwardProp: ( prop: string ) => prop !== "isSelected" } )<{ isSelected: boolean }>(
    ( { isSelected } ) => ( {
        padding: 8,
        margin: 8,
        backgroundColor: cardColor,
        borderRadius: "4px",
        border: isSelected ? `2px solid ${PRETTY_BLUE}` : "2px solid transparent",
        width: "95%",
        cursor: isSelected ? "default" : "pointer",
        transition: "border 0.3s ease-in-out",
        "&:hover": !isSelected
            ? {
                border: `2px solid ${PRETTY_BLUE}`,
            }
            : {}
    } )
);

export const TakeRouteButton = styled( Button )( () => ( {
    marginTop: 16,
    borderRadius: "24px",
    backgroundColor: PRETTY_BLUE,
    color: "white",
    fontWeight: 200,
    fontSize: "16px",
    paddingTop: "6px",
    width: "100%",
    paddingBottom: "6px",
    transition: "background-color 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out",
    border: "2px solid transparent",
    "&:hover": {
        backgroundColor: "white",
        color: "black",
        border: `2px solid ${PRETTY_BLUE}`,
    },
} ) );

export const SelectRouteButton = styled( Button )( () => ( {
    marginTop: 16,
    borderRadius: "24px",
    backgroundColor: "white",
    color: "black",
    width: "100%",
    fontWeight: 200,
    fontSize: "16px",
    paddingTop: "6px",
    paddingBottom: "6px",
    transition: "background-color 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out",
    border: `2px solid ${PRETTY_BLUE}`,
    "&:hover": {
        backgroundColor: PRETTY_BLUE,
        color: "white",
        border: `2px solid ${PRETTY_BLUE}`,
    },
} ) );
